import { render, staticRenderFns } from "./addMultipleServiceOrder.vue?vue&type=template&id=5156d70a"
import script from "./addMultipleServiceOrder.vue?vue&type=script&lang=js"
export * from "./addMultipleServiceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports